console.log("[common.js] loaded", new Date().toISOString());

(function () {
  function init() {
    const lineCta = document.querySelector(".floating-nav");
    const sentinel = document.querySelector("#footer-sentinel");

    console.log("[common.js] init", { lineCta: !!lineCta, sentinel: !!sentinel });
    if (!lineCta || !sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        lineCta.classList.toggle("is-hidden", entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(sentinel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
